import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { SpecialFreightIdView } from '../../../../models/shipment-id-view.model';
import { API_URL } from '../../../../../services/config';
import { Observable } from 'rxjs';
import { getQueryStringFromObject } from '../../../../../common';
import { ShipmentSpecialFreightManagerEndpoint } from '../../constants';
import { LatestNotification } from '../../../monitoring/models';

@Injectable({ providedIn: 'root' })
export class ShipmentSpecialFreightNotificationsService {
  constructor(private http: WrapperHttpService) {}

  getShipmentSpecialFreightNotifications(specialFreightIdView: SpecialFreightIdView): Observable<LatestNotification[]> {
    return this.http
      .withLoading()
      .get<LatestNotification[]>(
        `${API_URL}${ShipmentSpecialFreightManagerEndpoint.Base}${
          ShipmentSpecialFreightManagerEndpoint.SpecialFreights
        }${ShipmentSpecialFreightManagerEndpoint.Notifications}?${getQueryStringFromObject(specialFreightIdView)}`,
      );
  }
}
